import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
}), 'ViewCarouselSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewCarouselSharp.js
// module id = 7078
// module chunks = 2